/* eslint-disable react/display-name */
import React, { memo, useEffect } from 'react';
import { reduxConnect } from '../../common';
import PropTypes from 'prop-types';
import { dataLayer, utilities } from '@weatherbug/common';
import { translate } from '../../common/translation/translate';

const { getUvDescriptionFromUVIndexUtil, isNumber } = utilities;

const mapStoreStateToProps = storeState => {
    const { uv } =  storeState;

    const appState = storeState.appState.appState || {};
    const { authId, secret, uvBaseUrl } = appState;

    const locality = appState.locality || {};
    const latitude = locality.Latitude;
    const longitude = locality.Longitude;

    const uvPeriods = uv?.uv?.uvp;

    const uvIndex = uvPeriods?.length > 0 && uvPeriods[0]?.ui;

    return {
        latitude,
        longitude,
        authId,
        secret,
        uvBaseUrl,
        uvIndex
    };
};

const mapDispatchToProps = {
    getUvByLatLon: dataLayer.actions.getUvByLatLon
};

export const UvIndexDetails = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ 
    latitude, 
    longitude, 
    authId, 
    secret, 
    uvBaseUrl, 
    uvIndex,  
    getUvByLatLon }) => {

    const uvDescriptionDetails =  getUvDescriptionFromUVIndexUtil(uvIndex);
    const uvDescription = translate(uvDescriptionDetails.uvIndexTranslateKey);

    useEffect(() => {
        const fetchUVData = async() => {
            await getUvByLatLon(latitude, longitude, uvBaseUrl, authId, secret);
        };
        fetchUVData();

    }, [latitude, longitude, uvIndex]);

    return  isNumber(uvIndex) && uvIndex >= 0 ? `${uvIndex} (${uvDescription})`: `${uvDescription}`;
}));

UvIndexDetails.propTypes = {
    latitude: PropTypes.string,
    longitude: PropTypes.string,
    authId: PropTypes.string,
    secret: PropTypes.string,
    getUvByLatLon: PropTypes.func,
    uvIndex: PropTypes.number
};

UvIndexDetails.displayName = 'UvIndexDetails';
